import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { IMaskInput } from "react-imask";


interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value?: string;
}

const MoneyMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      onAccept={(value: string, mask: any) => {
        if (mask.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});



type Props = {
  name: string,
  label: string,
  error?: boolean,
  helperText?: string,
  readOnly?: boolean,
  value?: string,
  onChange: (value: string) => void,
};

export const MoneyMaskedInput2 = ({
  name,
  label,
  error,
  helperText,
  value,
  readOnly = false,
  onChange,
}: Props) => {

  const [internalValue, setInternalValue] = useState('');

  useEffect(() => {
    if (value !== undefined && value !== null && value !== '') {
      const valorNumerico = Number(value);
      if (!isNaN(valorNumerico)) {
        const valorParaMascara = valorNumerico.toFixed(2).replace('.', '');
        setInternalValue(valorParaMascara);
      }
    } else {
      setInternalValue('');
    }
  }, [value]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = event.target.value;
    setInternalValue(valorDigitado);

    if (!valorDigitado) {
      onChange('');
      return;
    }

    const valorDecimalReal = (Number(valorDigitado) / 100).toString();
    onChange(valorDecimalReal);
  }, [onChange]);

  return (
    <FormControl variant="outlined" size="small" fullWidth={true}>
      <InputLabel htmlFor={`input-${name}`} shrink={true} size="small" error={error}>
        {label}
      </InputLabel>

      <OutlinedInput
        size="small"
        id={`input-${name}`}
        name={name}
        value={internalValue}
        label={label}
        notched={true}
        readOnly={readOnly}
        error={error}
        fullWidth={true}
        aria-describedby={`${name}-component-error-text`}
        onChange={handleChange}
        inputComponent={MoneyMaskedInputBase as any}
        inputProps={{
          mask: [
            { mask: 'R$ \\0,\\00' },
            { mask: 'R$ \\0,00' },
            { mask: 'R$ 0,00' },
            { mask: 'R$ 00,00' },
            { mask: 'R$ 000,00' },
            { mask: 'R$ 0.000,00' },
            { mask: 'R$ 00.000,00' },
            { mask: 'R$ 000.000,00' },
            { mask: 'R$ 0.000.000,00' },
            { mask: 'R$ 00.000.000,00' },
            { mask: 'R$ 000.000.000,00' },
          ],
          placeholder: "R$ ___.___.___,__",
        }}
      />

      <FormHelperText id={`${name}-component-error-text`} error={true}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}